import { ScrollView, StyleSheet, View } from "react-native";
import { useResponsive } from "../hooks/useResponsive";
import { OPEN_MENU_HEIGHT } from "./MobileMenu";

const styles = StyleSheet.create({
  scrollContainer: {
    width: "100%",
  },
  contentContainer: {
    height: "100%",
    width: "100%",
    marginHorizontal: "auto",
  },
});

type Props = {
  paddingHorizontal?: number;
  paddingVertical?: number;
  maxWidth?: number;
  verticalCenter?: number; // between 0 and 1
  children: React.ReactNode;
};

export const FullScreenScrollView: React.FC<Props> = ({
  paddingHorizontal: pH,
  paddingVertical: pV,
  maxWidth,
  verticalCenter = 0,
  children,
}) => {
  const deviceSize = useResponsive();
  const isMobile = deviceSize === "mobile";

  const paddingHorizontal = pH ?? (isMobile ? 24 : 36);
  const paddingVertical = pV ?? (isMobile ? 36 : 60);

  return (
    <ScrollView
      style={styles.scrollContainer}
      contentContainerStyle={[
        styles.contentContainer,
        {
          paddingHorizontal,
          maxWidth,
        },
      ]}
    >
      <View style={{ minHeight: paddingVertical, flex: verticalCenter }} />
      {children}
      <View
        style={{
          minHeight: isMobile ? OPEN_MENU_HEIGHT : paddingVertical,
          flex: 1 - verticalCenter,
        }}
      />
    </ScrollView>
  );
};
